import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { ToasterService } from "./toaster.service";

@Injectable({
  providedIn: 'root',
})
export class VehicleAlertWebSocketService {
  private socket!: WebSocket;
  public messages$ = new Subject<any>();

  constructor(private toasterService: ToasterService) { }

  connect(id: number) {
    const url = `${environment.alertWebSocketUrl}${id}`;
    this.socket = new WebSocket(url);

    this.socket.onmessage = (event: any) => {
      console.log(event);
      try {
        const message = JSON.parse(event.data);
        this.toasterService.toastWarningWithTitle(message.title, message.message);
      } catch (e) {
        console.log(e);
        console.warn('Non-JSON message received:', event.data);
      }
    };

    this.socket.onerror = (error) => {
      if (error instanceof ErrorEvent) {
        console.error('WebSocket Error:', error.message);
      } else {
        console.error('WebSocket Error: Connection failed!', error);
      }
    };
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }
}
